export default class CarouselInnerContainerElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('carousel-inner-container', CarouselInnerContainerElement);